// src/components/ShopsHeader.jsx
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { MdArrowBack } from 'react-icons/md'
import { AiFillShopping, AiFillHeart, AiOutlineSearch } from 'react-icons/ai'

const ShopsHeader = ({ title, count }) => {
  const navigate = useNavigate()
  const { userInfo } = useSelector(state => state.auth)
  const { card_product_count, wishlist_count } = useSelector(state => state.card)

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-white shadow-sm sticky top-0 z-20">
      {/* — Back + Home logo */}
      <div className="flex items-center">
        <button
          onClick={() => navigate(-1)}
          className="p-1 text-2xl text-gray-600 hover:text-gray-800"
        >
          <MdArrowBack />
        </button>
        <button
          onClick={() => navigate('/')}
          className="ml-2 p-1 hover:opacity-80"
        >
          <img
            src="/images/HomeBack.png"
            alt="Go Home"
            className="h-9 object-contain"
          />
        </button>
      </div>

      {/* — Title + Count */}
      <div className="flex-1 mx-4 text-center">
        <h1 className="text-lg font-semibold text-gray-800">{title}</h1>
        <p className="text-sm text-gray-500">
          {count.toLocaleString()} items
        </p>
      </div>

      {/* — Cart, Wishlist & Search */}
      <div className="flex items-center space-x-4">
        {/* Cart */}
        <button
          onClick={() => navigate(userInfo ? '/card' : '/login')}
          className="relative flex justify-center items-center w-[35px] h-[35px] rounded-full bg-[#e2e2e2] hover:bg-gray-300"
        >
          <AiFillShopping className="text-xl text-orange-500" />
          {card_product_count > 0 && (
            <span className="absolute -top-[3px] -right-[5px] w-[20px] h-[20px] bg-green-500 rounded-full text-white text-xs flex items-center justify-center">
              {card_product_count}
            </span>
          )}
        </button>

        {/* Wishlist */}
        <button
          onClick={() => navigate(userInfo ? '/dashboard/my-wishlist' : '/login')}
          className="relative flex justify-center items-center w-[35px] h-[35px] rounded-full bg-[#e2e2e2] hover:bg-gray-300"
        >
          <AiFillHeart className="text-xl text-red-500" />
          {wishlist_count > 0 && (
            <span className="absolute -top-[3px] -right-[5px] w-[20px] h-[20px] bg-green-500 rounded-full text-white text-xs flex items-center justify-center">
              {wishlist_count}
            </span>
          )}
        </button>

        {/* Search */}
        <button
          onClick={() => navigate('/search')}
          className="p-1 text-xl text-gray-600 hover:text-gray-800"
        >
          <AiOutlineSearch />
        </button>
      </div>
    </div>
  )
}

export default ShopsHeader
